var map = {
	"./camp.png": 2025,
	"./circle.svg": 1798,
	"./creative.png": 2026,
	"./frontend.png": 2027,
	"./gamedesign.png": 2028,
	"./graphicdesign.png": 2029,
	"./junior.png": 2030,
	"./math-3-4.png": 2031,
	"./math-5-6.png": 2032,
	"./pc.png": 2033,
	"./pytpro-nosnake.png": 2034,
	"./pytpro.png": 2035,
	"./pytstart-nosnake.png": 2036,
	"./pytstart.png": 2037,
	"./quadrangle.svg": 1796,
	"./unity.png": 2038,
	"./videocontent.png": 2039,
	"./websites.png": 2040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;